import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { debounce } from 'throttle-debounce';
import { Checkbox, Field, Spacer, Text, Textarea } from '@ontruck/orc';
import Tooltip from 'components/Tooltip';
import SpecialIntructionsTooltip from 'components/summary/SpecialInstructionsTooltip';

const WAIT_INTERVAL = 700;

class AditionalOption extends PureComponent {
  constructor(props) {
    super(props);
    const { onValueChange, fieldType } = this.props;
    this.FieldClass = fieldType === 'textarea' ? Textarea : Field;
    this.debouncedOnValueChange = debounce(WAIT_INTERVAL, onValueChange);
  }

  render() {
    const {
      className,
      value,
      name,
      checkboxName,
      checkboxLabel,
      checked,
      onCheck,
      fieldType,
      fieldLabel,
      hasError,
      clarificationText,
      clarificationTextTooltipText,
      onBlur,
      onFocus,
      fullWidth,
      asideRightText,
      resize,
      height,
      t,
      image,
      isRecurring,
      checkboxDisabled,
    } = this.props;
    return (
      <Spacer className={className} mTop="M" mBottom="L">
        <Spacer mRight="S">
          <Checkbox
            id={checkboxName}
            name={t(checkboxName)}
            size="L"
            onChange={onCheck}
            checked={checked}
            disabled={checkboxDisabled}
          />
        </Spacer>

        <Spacer className="payload">
          <div className="checkboxLabel">
            <span className="label">
              {t(`${checkboxLabel}${isRecurring ? '_recurring' : ''}`)}
            </span>
            {image && <img src={`./${image}`} alt={`${image}`} />}
          </div>

          {checked && (
            <div className="fieldWrapper">
              <this.FieldClass
                type={fieldType}
                name={name}
                label={t(fieldLabel)}
                onChange={this.debouncedOnValueChange}
                size="XL"
                error={hasError}
                onBlur={onBlur}
                onFocus={onFocus}
                fullWidth={fullWidth}
                asideRightText={asideRightText}
                resize={resize}
                height={height}
                defaultValue={value}
                maxLength={255}
              />
            </div>
          )}
          {checked && (
            <Spacer mTop="S">
              {clarificationText && (
                <Text color="grey700">{t(clarificationText)} </Text>
              )}
              {clarificationTextTooltipText && (
                <span className="specialInstructions">
                  <Tooltip
                    component={<SpecialIntructionsTooltip t={t} />}
                    segmentTitle="summary aditional option"
                  >
                    {t(clarificationTextTooltipText)}
                  </Tooltip>
                </span>
              )}
            </Spacer>
          )}
        </Spacer>
      </Spacer>
    );
  }
}

AditionalOption.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  checkboxName: PropTypes.string,
  checkboxLabel: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  height: PropTypes.string,
  resize: PropTypes.string,
  fieldType: PropTypes.oneOf(['number', 'textarea', 'text']),
  fieldLabel: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  clarificationText: PropTypes.string,
  clarificationTextTooltipText: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  asideRightText: PropTypes.string,
  t: PropTypes.func,
  image: PropTypes.string,
  value: PropTypes.any,
  isRecurring: PropTypes.bool,
};

AditionalOption.defaultProps = {
  className: '',
  checkboxName: '',
  checkboxLabel: '',
  fieldType: 'text',
  fieldLabel: '',
  hasError: false,
  fullWidth: true,
  clarificationText: '',
  clarificationTextTooltipText: null,
  asideRightText: '',
  resize: 'none',
  height: '',
  t: () => {},
  image: '',
  value: '',
  isRecurring: false,
};

export default AditionalOption;
